import * as React from 'react';
import { connect } from 'react-redux';
import { Card, Image } from 'react-bootstrap';
import './PolicyDetails.css';
import { DASHBOARD, PERSONAL_INSURANCE, FNOL_SUBMIT_CLAIM } from '../../../routes/routes';
import KPBreadCrumb from '../../KPBreadCrumb/KPBreadCrumb';
import { useSelector, useDispatch } from 'react-redux'
import { showComingSoon, showCallMeModal } from '../../../actions/modalActions';
import { navigateTo } from '../../../actions/navigationActions';
import { setCoverFromPersonalInsurance, clearSelectedDamages, resetFNOL, setStep  } from '../../../actions/claimSubmitActions';
import { BUILDING_PRODUCT_ID, HOME_CONTENT_PRODUCT_ID } from '../../../constants/products';
import OptionalExtraTile from "../OptionalExtraTile";

const PolicyDetailsContentBuilding = () => {
    const profileState = useSelector(state => state.profile);
    const cover = useSelector(state => state.profile.selectedPersonalCover)
    const dispatch = useDispatch();

    function currencyThousandSeperator(tmp){
        let symbol = profileState.currencySymbol;
        let number = Number(tmp.replace(/((N\$)?)+[R ,]*/g, ''));
        let strNumber = symbol + " " + new Intl.NumberFormat('en-Uk').format(number);

        return strNumber;
    }

    function editPolicyInfo() {
        dispatch(showComingSoon());
    }

    async function submitAClaim() {
        await dispatch(resetFNOL());
        await dispatch(clearSelectedDamages());
        await dispatch(setCoverFromPersonalInsurance(cover));
        await dispatch(setStep(1, 1));
        await dispatch(navigateTo(FNOL_SUBMIT_CLAIM));
    }

    function handleSelfInspectionRequired() {
        dispatch(showComingSoon());
    }

    function handleCallMeBack() {
        dispatch(showCallMeModal(true));
    }

    const isMobile = window.innerWidth <= 975;
    let BreadcrumbDetails = [{ destination: DASHBOARD, description: "Home" }, { destination: PERSONAL_INSURANCE, description: "Personal insurance" }]
    let productName = (cover.product === HOME_CONTENT_PRODUCT_ID) ? "Home contents" : "Buildings";
    let coverStartDate = (cover.riskItems[0].coverStartDate?.toString().trim().length > 0) ? cover.riskItems[0].coverStartDate : "";
    let vapsList = "";

    if (cover.vaps) {
        if (cover.vaps.length > 0) {
            vapsList = cover.vaps.map((item) => {
                    return <OptionalExtraTile id={item.id}
                                              hasVAP={item.isActive}
                                              productName={item.title}
                                              imageClass={item.icon}
                                              addItem={handleSelfInspectionRequired}
                                              removeItem={handleSelfInspectionRequired}
                                              canUse={false}
                                              cost={profileState.currencySymbol + " " + item.premiumText + " pm"}
                                              isAccessory={false} />
            })
        }
    }

    return (
        <>
            {isMobile && cover.product === BUILDING_PRODUCT_ID &&
                <KPBreadCrumb navList={BreadcrumbDetails} activePage="Buildings" />
            }
            {isMobile && cover.product === HOME_CONTENT_PRODUCT_ID &&
                <KPBreadCrumb navList={BreadcrumbDetails} activePage="Content" />
            }
            <div className="box mb-3">
                <div className="d-lg-block d-none" id="PolicyDetails">
                    <div className="p-3">
                        <div id="firstDiv">
                            <div className="row mb-lg-0">
                                <div className="col-7">
                                    <h1 className="carName mb-2">{productName}</h1>
                                </div>
                                <div className="col-5 text-right">
                                    <button className="btn btn-outline-red mt-3" onClick={editPolicyInfo}>Update
                                        policy
                                    </button>
                                </div>
                                <div className="col-7">
                                    <h3 className="mb-2">{cover.riskItems[0].description}</h3>
                                </div>
                                <div className="col-lg-5 text-right">
                                    <button className="btn btn-solid-aqua mt-2" onClick={submitAClaim}>Submit a claim
                                    </button>
                                </div>

                            </div>
                            <div className="row">
                                <div className="col-lg-7">
                                    <p className="mb-0">Comprehensive cover</p>
                                    <h3 className="coverAmount mb-3">{currencyThousandSeperator(cover.riskItems[0].premium)} pm</h3>
                                    {coverStartDate.length > 0 &&
                                        <div>
                                            <p className="font-weight-normal line-height-normal mb-0">Cover start
                                                date</p>
                                            <p className="font-size-16px font-weight-bold line-height-normal mb-0">{coverStartDate}</p>
                                        </div>
                                    }
                                </div>
                            </div>
                            <hr className="building-contents-hr"/>
                            <div className="row">
                                <div className="col-lg-8">
                                    <p className="mb-2"><b>Excess amount</b></p>
                                    <p className="excessAmount"> {currencyThousandSeperator(cover.riskItems[0].excess)}</p>
                                    <p className="">Insured
                                        for {currencyThousandSeperator(cover.riskItems[0].insuredForValue)}</p>
                                </div>
                                {cover.riskItems[0].inspectionRequired &&
                                    <div className="col-lg-4 text-right">
                                        <button className="btn self-inspection-button"
                                                onClick={handleSelfInspectionRequired}>Self-inspection required
                                        </button>
                                    </div>
                                }
                            </div>
                        </div>
                        <hr className="policy-details-hr mt-14px mb-30px"/>
                        <div id="OptionalExtras" className="mt-lg-4">
                            <>
                                {vapsList &&
                                    <>
                                        <p className="font-size-16px font-weight-bold line-height-normal mb-10px">Optional
                                            cover</p>
                                        <p className="font-weight-500 line-height-normal mb-10px">Here’s a list of the
                                            optional extra cover you’ve added to your policy…</p>
                                        <div id="OptionalExtras">
                                            {vapsList}
                                        </div>
                                    </>
                                }
                            </>
                        </div>
                    </div>
                </div>

                <div className="d-lg-none d-block" id="PolicyDetailsMobile" style={{display: "none"}}>
                    <div className="pl-3 pr-3">
                        <div className="border-bottom pt-2">
                            <div id="firstDivMobile">
                                <div className="mb-lg-0">
                                    <div>

                                        <h1 className="carName mb-2 mt-3">{productName}</h1>
                                    </div>
                                </div>
                                <div className="mb-lg-0">
                                    <div>
                                        <h3 className="description mb-2">{cover.riskItems[0].description}</h3>
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <p className="mb-2">Comprehensive cover</p>
                                    <h3 className="coverAmount mb-3">{currencyThousandSeperator(cover.riskItems[0].premium)} pm</h3>
                                    {coverStartDate.length > 0 &&
                                        <div>
                                            <p className="font-weight-normal line-height-normal mb-0">Cover start
                                                date</p>
                                            <p className="font-size-16px font-weight-bold line-height-normal mb-0">{coverStartDate}</p>
                                        </div>
                                    }
                                </div>
                                <div className="mb-3">
                                    <div>
                                        <button className="btn btn-outline-red" onClick={editPolicyInfo}>Update policy
                                        </button>
                                    </div>
                                </div>
                                <div className="mb-3">
                                    <div>
                                        <button className="btn btn-solid-aqua" onClick={submitAClaim}>Submit a claim
                                        </button>
                                    </div>
                                </div>
                                {cover.riskItems[0].inspectionRequired &&
                                    <div className="mb-3">
                                        <div>
                                            <button className="btn btn-solid-red"
                                                    onClick={handleSelfInspectionRequired}>Self-inspection required
                                            </button>
                                        </div>
                                    </div>
                                }
                            </div>
                        </div>
                        <div className="border-bottom mt-3">
                            <div>
                                <p className="mb-1"><b>Excess amount</b></p>
                                <p className="excessAmount">{currencyThousandSeperator(cover.riskItems[0].excess)}</p>
                                <p className="">Insured
                                    for {currencyThousandSeperator(cover.riskItems[0].insuredForValue)}</p>
                            </div>
                        </div>
                        <div id="OptionalExtras" className="mt-3">
                            <>
                                {vapsList &&
                                    <>
                                        <p className="font-size-16px font-weight-bold line-height-normal mb-10px">Optional
                                            cover</p>
                                        <p className="font-weight-500 line-height-normal mb-10px">Here’s a list of the
                                            optional extra cover you’ve added to your policy…</p>
                                        <div id="OptionalExtras">
                                            {vapsList}
                                        </div>
                                    </>
                                }
                            </>
                        </div>

                    </div>
                </div>
            </div>
            <Card className="mt-3 mb-5">
                <Card.Body>
                    <div className="row">
                        <div className="col-lg-1 col-3">
                            <div
                                className={cover.product === HOME_CONTENT_PRODUCT_ID ? "home-content" : "buildings"}></div>
                        </div>
                        <div className="col-lg-11 col-9">
                            <div className="row">
                                <div className="col-10 px-0 mt-3">
                                    <p className="mb-0 ml-lg-2 mr-5">
                                        <b>Insure {cover.product === HOME_CONTENT_PRODUCT_ID ? "more home contents" : "another building "}</b>
                                    </p>
                                </div>
                                <div className="col-2 mt-2 pl-0 pl-lg-2" style={{paddingTop: "2px"}}>
                                    <Image src="./Images/TopNav/add-cover-nugreen-46px-46px.svg"
                                           className="mx-auto d-block cursor-pointer" onClick={handleCallMeBack}
                                           style={{height: "30px"}}/>
                                </div>
                            </div>
                        </div>
                    </div>
                </Card.Body>
            </Card>
        </>
    )
}

const mapStateToProps = (state: any) => {
    return {
        profile: state.profile,
    }
}

const mapDispatchToProps = (dispatch: any) => {
    return {}
}

export default connect(mapStateToProps, mapDispatchToProps)(PolicyDetailsContentBuilding);